import dynamic from "next/dynamic";
import { Avatar } from "shared/components/atoms/Avatar";
import { StarRating } from "shared/components/molecules/StarRating";
import { FortuneTeller } from "shared/types";

const Skeleton = dynamic(
  async () => await (await import("shared/components/atoms/Skeleton")).Skeleton
);

interface Props {
  fortuneTeller: FortuneTeller | undefined;
  className?: string;
}

export const ProfileCard = ({ fortuneTeller, className }: Props) => {
  return (
    <div tw="flex items-center" className={className}>
      <div tw="mr-3">
        <Avatar
          src={fortuneTeller?.imageUrl}
          fallback={fortuneTeller?.thumbnailUrl}
          size={48}
        />
      </div>
      <div>
        {fortuneTeller?.name ? (
          <div tw="font-base text-sm">{fortuneTeller?.name}</div>
        ) : (
          <Skeleton tw="w-full h-3 rounded" />
        )}
        <StarRating rate={fortuneTeller?.averageScore} size="large" tw="mt-2" />
      </div>
    </div>
  );
};
